import React, { useEffect, useRef } from 'react';
import styles from './NotificationsDropdown.module.scss';
import { Box } from 'new/elements/Box';
import { Button } from 'new/elements/Button';
import { NotificationsListView } from 'new/elements/Notifications/NotificationsListView';
import { ReactComponent as SettingsIcon } from 'new/components/icons/settings.svg';
import { useHistory } from 'react-router-dom';
import { NotificationSettings } from 'new/components/monitor/NotificationSettings';
import { Notifications } from 'new/components/monitor/Notifications';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { loadUnreadNotifications, markAllNotificationsAsRead } from 'js/actions';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import {
  GET_ALL_NOTIFICATIONS_REQUEST,
  GET_UNREAD_NOTIFICATIONS_REQUEST,
} from 'js/constants/actionTypes';
import { MAIN_ALL } from 'js/constants/notificationsTypes';
import { loadAllNotifications } from 'js/actions';

interface NotificationsDropdownProps {
  notifications: any[];
}

export const NotificationsDropdown = (props: NotificationsDropdownProps) => {
  const { notifications } = props;
  const notificationContainer = useRef();
  const history = useHistory();
  const dispatch = useDispatch<ThunkDispatch<any, any, Action>>();

  const loading =
    useIsLoading(GET_UNREAD_NOTIFICATIONS_REQUEST) || useIsLoading(GET_ALL_NOTIFICATIONS_REQUEST);

  useEffect(() => {
    dispatch(loadUnreadNotifications());
    dispatch(loadAllNotifications(MAIN_ALL, 20, 0, 1));
  }, []);

  const markAllAsRead = () => {
    dispatch(markAllNotificationsAsRead());
  };

  const onClickSettings = () => {
    history.push(NotificationSettings.screenConfig.path as string);
  };

  const onClickAll = () => {
    history.push(Notifications.screenConfig.path as string);
  };
  return (
    <Box
      title="Notifications"
      rightView={<Button onClick={markAllAsRead}>Mark all as read</Button>}
      className={styles.box}
    >
      <div
        ref={notificationContainer}
        className={!notifications.length ? styles.content : styles.contentData}
      >
        <NotificationsListView loading={loading} showResource compact items={notifications} />
      </div>
      <div className={styles.footer}>
        <Button onClick={onClickAll}>View all notifications</Button>
        <Button onClick={onClickSettings} startIcon={<SettingsIcon />}>
          Notification Settings
        </Button>
      </div>
    </Box>
  );
};
